import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Divisions = () => {
  const { t } = useLang();
  const [divisions, setDivisions] = useState([]);
  useEffect(() => {
    axios.get(`${API}/divisions`).then((r) => setDivisions(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="divisions-page" className="pt-32 pb-20">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <p className="overline mb-4">{t("divisionsPage.overline")}</p>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95] text-white mb-6">
            {t("divisionsPage.title1")} <br />
            <span className="italic text-[#C5A059]">{t("divisionsPage.title2")}</span>
          </h1>
          <p className="text-[#A1A1AA] leading-relaxed text-lg">
            {t("divisionsPage.subtitle")}
          </p>
        </div>

        <div className="space-y-24 md:space-y-32">
          {divisions.map((d, idx) => {
            const reverse = idx % 2 === 1;
            const linkMap = {
              sneakers: "/sneakers",
              wigs: "/perruques",
              couture: "/haute-couture",
              epicerie: "/epicerie",
              patisserie: "/patisserie",
              printing: "/printing",
            };
            const link = linkMap[d.id];
            return (
              <article
                key={d.id}
                data-testid={`division-section-${d.id}`}
                className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center ${
                  reverse ? "md:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="md:col-span-7">
                  <div className="relative aspect-[4/3] overflow-hidden bg-[#0f0f0f]">
                    <img src={d.image} alt={d.name} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  </div>
                </div>
                <div className="md:col-span-5">
                  <span className="font-display text-5xl text-[#C5A059]">{d.accent}</span>
                  <h2 className="font-display text-4xl md:text-5xl tracking-tighter text-white mt-4 mb-3 leading-tight">
                    {d.name}
                  </h2>
                  <p className="text-[#C5A059] font-grotesk text-sm mb-5 italic">{d.tagline}</p>
                  <p className="text-[#A1A1AA] leading-relaxed mb-8 max-w-md">{d.description}</p>
                  <Link to={link} data-testid={`division-cta-${d.id}`} className="btn-gold">
                    {t("divisionsPage.cta")} <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Divisions;
